import React, { useMemo, useState } from "react";
import { createSocialPost } from "../api";
import { useAuth } from "./AuthGate";
import styles from "../styles/SocialNetwork.module.css";

const tagsFromText = (text) => {
  const found = [];
  for (const match of String(text).matchAll(/(^|\s)([#@])([\w.-]+)/g)) {
    found.push({ tag_type: match[2] === "@" ? "mention" : "topic", value: match[3] });
  }
  return found;
};

export default function SocialPostComposer({ onCreated, repostOf = null, roomContext = null }) {
  const { user, profile } = useAuth();
  const [body, setBody] = useState("");
  const [visibility, setVisibility] = useState("public");
  const [imageUrl, setImageUrl] = useState("");
  const [imageName, setImageName] = useState("");
  const [expanded, setExpanded] = useState(!!repostOf);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const initial = (profile?.display_name || user?.displayName || user?.email || "U")[0].toUpperCase();
  const canPost = useMemo(() => !!(body.trim() || repostOf), [body, repostOf]);
  if (!user) return <div className={styles.composer}><span className={styles.subtle}>Sign in to join the conversation.</span></div>;
  const submit = async (event) => {
    event.preventDefault();
    if (!canPost) return;
    setSaving(true); setError("");
    try {
      const created = await createSocialPost({
        body: body.trim(),
        visibility,
        image_url: imageUrl.trim() || null,
        repost_of_post_id: repostOf?.id || null,
        room_context: roomContext,
        tags: tagsFromText(body),
      });
      setBody(""); setImageUrl(""); setImageName(""); setExpanded(false); onCreated?.(created);
    } catch (e) { setError(e?.response?.data?.detail || "Could not publish this post."); }
    finally { setSaving(false); }
  };
  return <form className={styles.composer} onSubmit={submit}>
    <div className={styles.composerRow}>
      {user.photoURL ? <img className={styles.avatar} src={user.photoURL} alt="" /> : <span className={styles.avatar}>{initial}</span>}
      <textarea className={styles.textarea} value={body} onFocus={() => setExpanded(true)} onChange={(e) => setBody(e.target.value)} rows={expanded ? 3 : 1} maxLength={2000} placeholder={repostOf ? "Add your take…" : "What’s happening in sport?"} />
    </div>
    {expanded && <div className={styles.composerTools}>
      <label className={styles.mediaButton}>＋ Image<input type="file" accept="image/jpeg,image/png,image/webp,image/gif" hidden onChange={(event) => {
        const file = event.target.files?.[0]; if (!file) return;
        if (file.size > 3_000_000) { setError("Choose an image smaller than 3 MB."); return; }
        const reader = new FileReader(); reader.onload = () => { setImageUrl(String(reader.result || "")); setImageName(file.name); }; reader.readAsDataURL(file);
      }} /></label>
      {imageName ? <span className={styles.subtle}>{imageName} <button type="button" className={styles.action} onClick={()=>{setImageUrl("");setImageName("");}}>Remove</button></span> : null}
      <select className={styles.select} value={visibility} onChange={(e) => setVisibility(e.target.value)}><option value="public">Everyone</option><option value="followers">Followers</option></select>
      <button className={styles.primary} disabled={saving || !canPost}>{saving ? "Posting…" : "Post"}</button>
    </div>}
    {error && <span className={styles.subtle} style={{color:"#fb7185"}}>{error}</span>}
  </form>;
}
